import auth from './auth/authSlice';
import history from './historySlice';
import permanentLicenses from './permanentLicensesSlice';
import objectData from './objectDataSlice';
import modals from './modalsSlice';
import trialLicenses from './trialLicensesSlice';
import clients from './clientsSlice';
import temporaryLicenses from './temporaryLicensesSlice';
import offlineLicenses from './offlineLicensesSlice';
import productReleases from './productReleasesSlice';
import objectHistory from './objectHistorySlice';
import adminHistory from './adminHistorySlice';
import userConfigs from './userConfigs';
import accounts from './accountsSlice';
import settings from './settingsSlice';
import licensesCommon from './licensesCommonSlice';
import devices from './devicesSlice';
import features from './featuresSlice';
import deviceFeatures from './deviceFeaturesSlice';
import trialRejectedDevices from './trialRejectedDevicesSlice';
import webViewerFeaturePackages from './webViewerFeaturePackagesSlice';
import webViewerServers from './webViewerServersSlice';
import webViewerLicenses from './webViewerLicensesSlice';
import trialSettings from './trialSettingsSlice';
import bannedDevices from './banSlice';

export {
  auth,
  history,
  objectData,
  permanentLicenses,
  modals,
  trialLicenses,
  clients,
  temporaryLicenses,
  offlineLicenses,
  productReleases,
  objectHistory,
  adminHistory,
  userConfigs,
  accounts,
  settings,
  licensesCommon,
  devices,
  features,
  deviceFeatures,
  trialRejectedDevices,
  webViewerFeaturePackages,
  webViewerServers,
  webViewerLicenses,
  trialSettings,
  bannedDevices,
};



// WEBPACK FOOTER //
// ./src/store/index.js